// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kJfc","controls":"styles_controls__Ce3Sg","charLimit":"styles_charLimit__20bx4","input":"styles_input__3qu2H","send":"styles_send__MlIf7"};